import Cookiebot from 'react-cookiebot/lib/CookieBot';
import { ErrorBoundary } from 'react-error-boundary';
import { Provider as ReduxProvider } from 'react-redux';
import { MsalProvider } from '@azure/msal-react';
import { SnackbarGlobal, ThemeProvider } from '@insuma/mpp-ui';
import { PersistGate } from 'redux-persist/integration/react';
import { COOKIEBOT_ID } from 'core/constants/general.constants';
import { insumaTheme } from 'core/constants/themes.constants';
import { ScreenProvider } from 'core/contexts/screen.context';
import store, { persistor } from '../core/store';
import msalPublicClientApplication from '../shared/utils/msal.utils';
import { RollbackInternalError } from './errors/rollback-internal-error';
import { MainRoutes } from './main.routes';

const ErrorFallback = () => <RollbackInternalError />;

const App = () => (
  <ErrorBoundary FallbackComponent={ErrorFallback}>
    <MsalProvider instance={msalPublicClientApplication}>
      <ThemeProvider theme={insumaTheme}>
        <SnackbarGlobal />
        {/* <WhatsappButton /> */}
        <ReduxProvider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            {COOKIEBOT_ID && <Cookiebot domainGroupId={COOKIEBOT_ID} />}
            <ScreenProvider>
              <MainRoutes />
            </ScreenProvider>
          </PersistGate>
        </ReduxProvider>
      </ThemeProvider>
    </MsalProvider>
  </ErrorBoundary>
);

export default App;
